export default {
  'subject-card.modules': 'Modules',
  'subject-card.module': 'Module',
  'subject-card.module.download': 'Documents',
  'subject-card.lessons': 'Lessons',
  'subject-card.lesson': 'Lesson',
  'subject-card.lesson.download': 'Documents',
};